// extracted by mini-css-extract-plugin
export default {"hero":"Hero_hero__xHrI7","textBox":"Hero_textBox__vJXzM","title":"Hero_title__H3Mql","paragraph":"Hero_paragraph__PBhCp","imageBox":"Hero_imageBox__gYDXZ"};